import * as React from 'react';
import { cn } from '@/lib/utils';

interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

// Top-level screen wrapper inside MainLayout.
// Main already clears the fixed bottom nav; this fills the viewport so short
// pages (Dashboard) don’t leave a dead scroll area, while tall content still
// grows and scrolls on the document.
export function Page({ children, className, ...props }: PageProps) {
  return (
    <div
      className={cn('flex min-h-full flex-1 flex-col', className)}
      {...props}
    >
      {children}
    </div>
  );
}
